module.exports = __webpack_public_path__ + "static/img/Warning.fc8bd8e.png";


//////////////////
// WEBPACK FOOTER
// /src/assets/images/Warning.png
// module id = 9Hd1
// module chunks = 1